import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import Table from "./Table";
import {
  getCadernosEncargos,
  getSpecificEncargo,
  setSpecificEncargo,
  getProfilesByEncargo,
  setProfilesByEncargo,
} from "~/store/ducks/cvManagement/actionTypes";
import CreateActionColumn from "../CreateActionColumn";
import { Card, Badge } from "react-bootstrap";
import ModalNew from "./ModalNew";
import { FaPersonCircleExclamation } from "react-icons/fa6";
import ModalProfiles from "./ModalProfiles";

const Concurso = ({ t }) => {
  const dispatch = useDispatch();
  const [cadernosEncargosData, setCadernosEncargosData] = useState([]);
  const [modalNew, setModalNew] = useState(false);
  const [modalProfiles, setModalProfiles] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 && configuration && configuration.mobileReady
  );

  const [rowCopy, setRowCopy] = useState({});

  const [rowSelectedCadernoEncargos, setRowSelectedCadernoEncargos] = useState(
    {}
  );

  const [profilesRowSelected, setProfilesRowSelected] = useState({});

  const { cadernosEncargosAllList, encargoDataSelected, profilesByEncargo } =
    useSelector((state) => state.cvManagementReducer);
  const { configuration } = useSelector((state) => state.adminConfigReducer);

  useEffect(() => {
    setIsMobile(
      window.innerWidth < 768 && configuration && configuration.mobileReady
    );
  }, [configuration]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768 && configuration && configuration.mobileReady
      );
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        Object.keys(rowSelectedCadernoEncargos).length === 0 &&
        Object.keys(profilesRowSelected).length === 0
      )
        dispatch(getCadernosEncargos());
    }, 210000);

    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    handleCloseModals();
    dispatch(getCadernosEncargos());
    setRowCopy({});
  }, []);

  useEffect(() => {
    setCadernosEncargosData([...cadernosEncargosAllList].reverse());
  }, [cadernosEncargosAllList]);

  useEffect(() => {
    if (Object.keys(profilesByEncargo).length > 0) {
      setProfilesRowSelected(profilesByEncargo);
      setModalProfiles(true);
    } else {
      setProfilesRowSelected({});
      setModalProfiles(false);
    }
  }, [profilesByEncargo]);

  const stateFormatter = (cell, row) => {
    let stateText = "";
    let variant = "secondary"; // cinza por padrão
    switch (cell) {
      case "OPEN":
        stateText = "Aberto";
        variant = "secondary"; // cinza
        break;
      case "ANALYSIS":
        stateText = "Em Análise";
        variant = "warning"; // laranja
        break;
      case "PENDING":
        stateText = "Pendente";
        variant = "warning"; // laranja
        break;
      case "SUBMITTED":
        stateText = "Submetido";
        variant = "success"; // verde
        break;
      case "EXPIRED":
        stateText = "Fim de Prazo";
        variant = "danger"; // vermelho
        break;
      case "FAILED":
        stateText = "Falhado";
        variant = "danger"; // vermelho
        break;
      default:
        stateText = "";
        variant = "";
    }

    return (
      <Badge pill variant={variant}>
        {stateText}
      </Badge>
    );
  };

  const dateFormatter = (cell) => {
    if (!cell) {
      return cell;
    }
    if (cell === null || cell === "" || cell === undefined) return "";
    var currentStringDate = cell;
    if (currentStringDate.length > 10) {
      currentStringDate = currentStringDate.slice(0, 10);
    }
    if (
      currentStringDate != null &&
      currentStringDate != undefined &&
      currentStringDate?.length > 0
    ) {
      const dateInfo = currentStringDate.split("-");
      const str = dateInfo[2] + "/" + dateInfo[1] + "/" + dateInfo[0];

      return <div style={{ display: "flex", alignItems: "center" }}>{str}</div>;
    } else {
      return <div style={{ display: "flex", alignItems: "center" }}></div>;
    }
  };

  useEffect(() => {
    if (Object.keys(encargoDataSelected).length > 0) {
      setRowSelectedCadernoEncargos(encargoDataSelected);
      setModalNew(true);
    } else {
      setRowSelectedCadernoEncargos({});
      setModalNew(false);
    }
  }, [encargoDataSelected]);

  const selectRow = (row) => {
    if (row) {
      dispatch(getSpecificEncargo(row.id));
      setRowCopy(row);
    }
  };

  const selectProfileShow = (row) => {
    if (row) {
      dispatch(getProfilesByEncargo(row));
    }
  };

  const buildActionsColumn = (_, row, _rowIndex, formatExtraData) => (
    <CreateActionColumn
      select={selectRow}
      row={row}
      showProfile={true}
      selectProfileShow={selectProfileShow}
    />
  );

  const combinedActionsFormatter = (cell, row, rowIndex, formatExtraData) => {
    const actions = buildActionsColumn(cell, row, rowIndex, formatExtraData);

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ marginTop: "2rem" }}>{actions}</div>
      </div>
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "entidade",
      text: "Entidade",
      headerStyle: { width: "330px" },
      sort: true,
      style: { alignContent: "center" },
    },
    {
      dataField: "nome",
      text: "Nome do Caderno",
      headerStyle: { width: "fit-content" },
      sort: true,
      style: { alignContent: "center" },
    },
    {
      dataField: "dataLimite",
      text: "Data Limite",
      sort: true,
      headerStyle: { width: "140px" },
      formatter: dateFormatter,
      style: { alignContent: "center" },
    },
    {
      dataField: "estado",
      text: "Estado",
      sort: true,
      headerStyle: { width: "100px" },
      formatter: stateFormatter,
      style: { alignContent: "center" },
    },
    {
      dataField: "actions",
      text: "",
      sort: false,
      headerStyle: { width: "55px" },
      formatter: isMobile ? combinedActionsFormatter : buildActionsColumn,
      style: { alignContent: "center" },
    },
  ];

  const handleCloseModals = () => {
    setModalNew(false);
    setModalProfiles(false);
    setRowSelectedCadernoEncargos({});
    setProfilesRowSelected({});
    dispatch(setSpecificEncargo({}));
    dispatch(setProfilesByEncargo({}));
    setRowCopy({});
  };

  const indexProfiles = () => {
    setRowSelectedCadernoEncargos({});
    setProfilesRowSelected({});
    selectProfileShow(rowCopy);
    setModalNew(false);
  };

  return (
    <>
      <ModalNew
        show={modalNew}
        onClose={handleCloseModals}
        isMobile={isMobile}
        rowSelectedCadernoEncargos={rowSelectedCadernoEncargos}
        cadernosEncargosData={cadernosEncargosData}
        indexProfiles={indexProfiles}
      />
      <ModalProfiles
        show={modalProfiles}
        onClose={handleCloseModals}
        isMobile={isMobile}
        profilesRowSelected={profilesRowSelected}
      />

      <div className="main-card-v2" style={{ height: "fit-content" }}>
        <Card bsPrefix="card-flat">
          <Card.Header className="justify-content-between">
            <h6>Encargos</h6>
          </Card.Header>
          <Card.Body>
            <Table
              columns={columns}
              dataList={cadernosEncargosData}
              setModalNew={setModalNew}
            />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default withNamespaces()(Concurso);
